/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Print_Maplabel1Inputs */

const zh_print_maplabel1 = /** @type {(inputs: Print_Maplabel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`标签`)
};

const en_print_maplabel1 = /** @type {(inputs: Print_Maplabel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Label`)
};

const es_print_maplabel1 = /** @type {(inputs: Print_Maplabel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etiqueta`)
};

/**
* | output |
* | --- |
* | "Label" |
*
* @param {Print_Maplabel1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const print_maplabel1 = /** @type {((inputs?: Print_Maplabel1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Print_Maplabel1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_print_maplabel1(inputs)
	if (locale === "en") return en_print_maplabel1(inputs)
	return es_print_maplabel1(inputs)
});
export { print_maplabel1 as "print_mapLabel" }